"use strict";

exports.__esModule = true;
var _DashboardEditor = require("./DashboardEditor");
Object.keys(_DashboardEditor).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DashboardEditor[key]) return;
  exports[key] = _DashboardEditor[key];
});